export const CANVAS_PADDING = 20;
